import { Box, Dialog, DialogContent, IconButton, Modal, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { saveAs } from 'file-saver';
import React, { useEffect, useRef, useState } from 'react';
import { MdOutlinePhoneIphone } from "react-icons/md";
import { useLocation, useParams } from 'react-router-dom';
// import { MdOutlineTextsms } from "react-icons/md";
// import { AiOutlineMail } from "react-icons/ai";
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import { ReactComponent as Download } from "../../Assets/img/icons/Download-share.svg";
import linkedin from '../../Assets/img/icons/linkedin.svg';
import telegram from '../../Assets/img/icons/Telegram.svg';
import { ReactComponent as WhatsappFilled } from '../../Assets/img/icons/whatsapp-filled.svg';
import whatsapp from '../../Assets/img/icons/whatsapp.svg';
// import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import CloseIcon from "@mui/icons-material/Close";
import axios from 'axios';
import QRCodeStyling from "qr-code-styling";
import DefaultProfileBg from "../../Assets/img/card/profilebg.png";
import DefaultLogo from "../../Assets/img/default-logo.png";
import { getIconAndLabel, socialLinksSections } from '../Utilities/SocialMediaMapping';
import QrCodeCard from "./Cards/QrCodeCard";
// import NeocardzWave from "../Utilities/NeocardzWave"
import ReactPlayer from 'react-player';
import { toast } from 'react-toastify';
import loaderGif from '../../Assets/img/icons/Animation - 1718370478484.gif';
import { ReactComponent as NonVerifiedTickNew } from "../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as ImQrcode } from "../../Assets/img/icons/QrCode_AllCards.svg";
import { ReactComponent as IoMdShare } from "../../Assets/img/icons/Share.svg";
import { ReactComponent as VerifiedTickN } from "../../Assets/img/icons/Verified-icon-new.svg";
import PreviewFileItem from '../Utilities/PreviewFileItem';
import { renderLayout } from './Cards/Layouts';
import MapWithAddress from './MapWithAddress';
import Vcfcard from './Vcfcard';


const CardView = () => {


    // const { id } = useParams();
    const viewerToken = localStorage.getItem('objectId');
    const apiKey = process.env.REACT_APP_API_KEY
    const { card, id } = useParams();
    const storedobjectId = id;

    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${storedobjectId}`
    };

    const location = useLocation();
    const [userProfile, setUserProfile] = useState("");
    const [objectId, setobjectId] = useState("");
    const [isIdAvailable, setIsIdAvailable] = useState(false);
    const [loading, setLoading] = useState(false);

    const isViewCard = location?.pathname.includes('view-card');
    axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
    const [isModalOpen, setModalOpen] = useState(false);

    const handleViewMoreClick = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };
    const maxImages = 5; // Maximum images to display in two rows (4 per row)

    useEffect(() => {
        // Check if id is available
        if (id) {
            // console.log('id: ',id, 'card: ', card);
            setIsIdAvailable(true);
        }
    }, [id]);

    const [cardDetails, setCardDetails] = useState({
        User_ID: objectId,
        employee_id: '',
        company_id: '',
        profession_department: '',
        profession_id: '',
        company_website: '',
        is_professional_verified: false,
        professional_details_status: '',
        student_id: '',
        student_email_id: '',
        student_year: '',
        student_ending_year: '',
        student_currently_pursuing: false,
        education_level: '',
        institute: '',
        board: '',
        degree: '',
        field_of_study: '',
        grade: '',
        is_student_verified: false,
        student_details_status: '',
        CardType: 'Personal',
        prefix: '',
        suffix: '',
        title: '',
        nickname: '',
        summary: '',
        designation: '',
        company: '',
        profession_department: '',
        professional_email_id: '',
        profile_pic: '',
        logo: ''
    });
    const [CardStyles, setCardStyles] = useState({
        User_ID: objectId,
        CardType: 'Professional',
        font: '',
        size: '',
        style: '',
        colorPrimary: '',
        colorSecondary: '',
        colorTitle: '',
        colorLayout: '#0044c6',
        bgColor: '#ffffff',
        imageExtract: null,
        layoutStyle: '1'
    })
    const [CardQrStyles, setCardQrStyles] = useState({
        User_ID: objectId,
        CardType: 'Professional',
        // logoQr :null,
        eyeBall: '',
        eyeBallcolor: '',
        eyeFrame: '',
        eyeFrameColor: '',
        qrPattern: '',
        qrPatterncolor: '#121212',
        border: '',
        bordercolor: '',
        addbg: '',
        addbgcolor: '#ede8e8'
    })
    const [SocialLinks, setSocialLinks] = useState({
        user_ref_id: objectId,
        card_type: 'Professional',
        links: [
            { network: 'linkedin', url: 'https://www.linkedin.com/in/', visible: false },
            { network: 'facebook', url: 'https://www.facebook.com/', visible: false },
            { network: 'instagram', url: 'https://www.instagram.com/', visible: false },
        ],
    })
    const [ContactStyles, setContactStyles] = useState({
        card_type: '',
        reference_id: objectId,
        location: '',
        mobile_number: userProfile?.phone_no || '',
        call_visible: true,
        sms_visible: true,
        email: userProfile?.email || '',
        email_visible: true,
        whatsapp: userProfile?.phone_no || '',
        whatsapp_visible: true,
        address: '',
        state: '',
        postal_code: '',
        city: '',
        country: '',
        is_public: true,
    })

    const [AttachDocs, setAttachDocs] = useState({
        user_ref_id: "",
        card_id: null,
        card_name: "",
        images: [],
        videos: [],
        others: []
    });
    const visibleFiles = (files) => files.filter(file => file.visible); // Hide the attached files that are marked invisible
    const visibleImages = visibleFiles(AttachDocs.images).slice(0, maxImages);

    const [profilePicture, setProfilePicture] = useState('');

    useEffect(() => {
        if (cardDetails?.profile_pic) {
            const profilePic = cardDetails.profile_pic;
            setProfilePicture(profilePic);
        }
        else {
            setProfilePicture(DefaultProfileBg);
        }
    }, [cardDetails]);

    const initialCardDetails = {
        User_ID: `${id}`,
        CardType: `${card}`,
        profile_pic: '',
        logo: '',
        employee_id: '',
        company_id: '',
        is_professional_verified: false,
        is_student_verified: false,
        prefix: '',
        suffix: '',
        title: '',
        nickname: '',
        summary: '',
        designation: '',
        company: '',
        profession_department: '',
    };

    const initialCardStyles = {
        User_ID: `${id}`,
        CardType: `${card}`,
        font: '',
        size: '',
        style: '',
        colorPrimary: '',
        colorSecondary: '',
        colorTitle: '',
        colorLayout: '#0044C6',
        bgColor: '#ffffff',
        imageExtract: null,
        layoutStyle: card === 'Personal' ? '2' : '1',
    };

    const initialCardQrStyles = {
        User_ID: `${id}`,
        CardType: `${card}`,
        eyeBall: '',
        eyeBallcolor: '',
        eyeFrame: '',
        eyeFrameColor: '',
        qrPattern: '',
        qrPatterncolor: '#121212',
        border: '',
        bordercolor: '',
        addbg: '',
        addbgcolor: '#ede8e8'
    };

    const initialCardSocialLinks = {
        User_ID: `${id}`,
        card_type: `${card}`,
        links: [
            { network: 'linkedin', url: '', visible: false },
            // { network: 'whatsapp', url: '', visible: false },
            { network: 'facebook', url: '', visible: false },
            { network: 'instagram', url: '', visible: false },
        ],
    }

    const initialContactStyles = {
        card_type: `${id}`,
        CardType: `${card}`,
        CardName: `${card}`,
        location: '',
        mobile_number: `${userProfile.phone_no}`,
        call_visible: true,
        sms_visible: true,
        email: `${userProfile.email}`,
        email_visible: true,
        whatsapp: '',
        whatsapp_visible: true,
        address: '',
        state: '',
        postal_code: '',
        city: '',
        country: '',
        is_public: true,
    }

    useEffect(() => {

        const fetchCardDetails = async () => {
            try {

                const userInfo = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`, {
                    headers: headers
                });
                // console.log("response in the group card", userInfo.data?.data?.user);
                // setUserProfile(userInfo.data);

                if (JSON.stringify(userProfile) !== JSON.stringify(userInfo.data?.data?.user)) {
                    setUserProfile(userInfo?.data?.data?.user);
                }
                // console.log("userProfile: ", userProfile);

                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/getParticularCardInfo`, {
                    params: {
                        CardName: `${card}`,
                        referenceId: `${id}`
                    },
                    headers: headers
                });

                // console.log('Fetched card details:', response);
                // if (response.data.Details.length > 0) {
                //   setCardDetails(response.data.Details[0]);
                // }
                if (response.data.Details.length > 0) {
                    const details = response.data.Details[0];

                    // Create a new object with renamed keys and omit the old key
                    const { user_ref_id, ...restDetails } = details; // Destructure to remove user_ref_id
                    const renamedDetails = {
                        ...restDetails,
                        User_ID: user_ref_id, // Add User_ID with the value of user_ref_id
                    };

                    // Set the renamed object to state
                    setCardDetails(renamedDetails);
                }
                else {
                    setCardDetails(initialCardDetails);
                }
                if (response.data.QrStyles.length > 0) {

                    setCardQrStyles(response.data.QrStyles[0]);
                }
                else {
                    setCardQrStyles(initialCardQrStyles);
                }
                if (response.data.CardDesigns.length > 0) {
                    setCardStyles(response.data.CardDesigns[0]);
                }
                else {
                    setCardStyles(initialCardStyles);
                }

                const response2 = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/get-social-links`, {
                    params: {
                        cardType: `${card}`,
                    },
                    headers: headers,
                });
                // console.log('Fetched social links:', response.data);
                // setSocialLinks(response.data);
                const transformedLinks = response2.data.map((link) => ({
                    network: link.info_key,
                    url: link.info_value,
                    visible: link.is_visible,
                }));

                // console.log('Transformed Links: ', transformedLinks)

                setSocialLinks({
                    user_ref_id: `${id}`,
                    card_type: `${card}`,
                    links: transformedLinks,
                });
                console.log(SocialLinks);

            }
            catch (error) {
                console.error("Error fetching card details:", error);
            }

            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/getcard-contacts`, {
                    params: {
                        card_type: `${card}`,
                    },
                    headers: headers,
                });
                if (response.status === 200) {
                    setContactStyles(response.data[0]);
                }
                else {
                    setContactStyles(initialContactStyles);
                }
            }
            catch (error) {
                console.log("It does not fetch the Card Contact Details");
                setContactStyles(initialContactStyles);
            }

            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/card_document/${card}`,
                    { headers: headers }
                );
                const { data } = response.data;

                if (data.length < 1) return;

                const restructuredData = {
                    user_ref_id: data.length ? data[0].user_ref_id : "",
                    card_id: data.length ? data[0].card_id : null,
                    card_name: id,
                    images: [],
                    videos: [],
                    others: []
                };

                data.forEach((doc) => {
                    const document = {
                        name: doc.document_name,
                        size: doc.size,
                        date: doc.date,
                        type: doc.document_type,
                        data: doc.public_url,
                        fileCat: doc.file_cat,
                        fileId: doc.file_id,
                        showQR: doc.showQR,
                        visible: doc.is_visible,
                    };

                    if (doc.file_cat === 'images') {
                        restructuredData.images.push(document);
                    } else if (doc.file_cat === 'videos') {
                        restructuredData.videos.push(document);
                    } else {
                        restructuredData.others.push(document);
                    }
                });

                // Update the state with the restructured data
                setAttachDocs(restructuredData);

            } catch (error) {
                console.error('Error fetching documents:', error);
                // Handle error accordingly, like showing an alert or a message to the user
            }

            setLoading(false);
            // handleCheckAccess();
        }


        fetchCardDetails();
    }, []);

    const firstName = userProfile?.first_name || "FirstName";
    const lastName = userProfile?.last_name || "LastName";
    const userCompany = cardDetails?.company || "Company";
    const userDesignation = cardDetails?.designation || "Designation";
    const userTitle = cardDetails?.title || "Designation";
    const [phoneNo, setPhoneNo] = useState(userProfile?.phone_no || "");
    const [sms, setSms] = useState(userProfile?.email || "");
    const userEmail = useState(userProfile?.email || "");
    const userWhatsapp = ContactStyles.whatsapp?.input || phoneNo || '';

    const companyLogo = cardDetails?.logo === null ? (
        DefaultLogo
    ) : cardDetails?.logo;


    const getFontWeight = (style) => {
        switch (style) {
            case 'Light':
                return 300; // Font weight for Light
            case 'Regular':
                return 500; // Font weight for Regular
            case 'Medium':
                return 600; // Font weight for Medium
            case 'Semi Bold':
                return 700; // Font weight for Semi Bold
            case 'Bold':
                return 800; // Font weight for Bold
            default:
                return 'normal'; // Default font weight
        }
    };

    const [dialogueOpen, setDialogueOpen] = useState(false);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const canvasToImage = (canvas, type) => {
        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(blob);
            }, type);
        });
    };

    // Function to handle download button click
    const handleDownload = async () => {
        const canvas = document.querySelector('canvas');
        const blob = await canvasToImage(canvas, 'image/png'); // Change to 'image/jpeg' for JPEG format
        saveAs(blob, 'qrcode.png'); // Change file name and extension accordingly
    };

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        "& .MuiDialogContent-root": {
            padding: theme.spacing(2),
        },
        "& .MuiDialogActions-root": {
            padding: theme.spacing(1),
        },
    }));

    const handleOpenDialogue = () => {
        setDialogueOpen(!dialogueOpen);
    };

    const handleCloseDialogue = () => {
        setDialogueOpen(false);
    };

    const handleClickOpen = () => {
        setPopoverOpen(!popoverOpen);
    };

    const handleClose = () => {
        setPopoverOpen(false);
    };

    const handleCheckAccess = async () => {
        console.log("hoskote card", card);

        if (!storedobjectId || !viewerToken || !CardStyles.CardType) {
            toast.error('All fields are required');
            return;
        }

        try {
            const response = await axios.post('api/v1/consent/check-access', {
                ownerToken: storedobjectId,
                viewerToken,
                cardName: card,
            });


            console.log("consent response ", response);


            if (response.data.access) {
                toast.success('Access granted to the card.');
            } else {
                toast.error(response.data.message || 'No access to the card.');
                handleAskConsent();
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'An error occurred.');
        }
    };


    const handleAskConsent = async () => {
        setLoading(true);
        // setError('');

        try {
            const response = await axios.post('api/v1/consent/request-access', {
                ownerId: storedobjectId,
                cardName: card,
                requesterId: viewerToken,
            });

            console.log("consent sent for request", response);


            if (response.status === 201) {
                toast.success('Your access request has been sent and is pending approval.');
            } else {
                toast.success('Sent consent request.');
            }
        } catch (err) {
            console.error(err);
            //   setError('An error occurred while sending your request.');
            toast.error('An error occurred while sending your request.');
        } finally {
            setLoading(false);
        }
    };

    // const borderStyle = CardQrStyles.border === "border" ? { border: `4px solid ${CardQrStyles.bordercolor || '#000000'}` } : {};
    const url1 = (`${process.env.REACT_APP_CARD_URL}/digital-identity/${card}/${id}`);

    const message = url1;
    const encodedMessage = encodeURIComponent(message);
    const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNo}&text=${encodedMessage}`;
    // const telegramUsername = "YourTelegramUsername"; 
    const telegramLink = `https://t.me/${phoneNo}?text=${encodedMessage}`;
    const linkedinPostLink = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedMessage}`;

    const anySocialIconsVisible = SocialLinks && SocialLinks.links?.some(link => link && link.visible);

    const getDisplayTitle = (title) => {
        switch (title) {
            case "Social Media":
                return "My Social Network";
            case "Business":
                return "My Businesses";
            case "Contact":
                return "My Contacts"
            case "Payment":
                return "My Payment Links"
            case "More":
                return "Others"
            case "Music":
                return "My Music"
            case "Portfolio":
                return "My Portfolio"
            case "Content":
                return "My Content"
            default:
                return title;
        }
    };

    const [Logo, setcompanyLogo] = useState('');
    useEffect(() => {

        if (cardDetails.logo && cardDetails.logo !== '') {
            // const companypic = `data:${cardDetails.CompanyLogo.type};base64,${cardDetails.CompanyLogo.data}`
            setcompanyLogo(cardDetails.logo);
            // console.log("logo in qr", companypic);
        }
        else {
            setcompanyLogo('')
        }
    }, [cardDetails]);

    useEffect(() => {
        if (ContactStyles.mobile_number) {
            setPhoneNo(ContactStyles.mobile_number);
        }
        else {
            setPhoneNo(userProfile.phone_no)
        }
        if (ContactStyles.email) {
            setSms(ContactStyles.email);
        }
        else {
            setSms(userProfile.email)
        }
    }, [ContactStyles, userProfile]);


    const [qrCodeOptions, setQrCodeOptions] = useState({
        dotsOptions: {
            color: "#000000",
            type: "square"
        },
        cornersSquareOptions: {
            color: "#000000",
            type: "square"
        },
        cornersDotOptions: {
            color: "#000000",
            type: "dot"
        },
        backgroundOptions: {
            color: "#ffff"
        }
    });

    const qrCodeRef = useRef(null);
    const qrCodeInstanceRef = useRef(null);
    // const [qrCodeSVG, setQrCodeSVG] = useState("");

    useEffect(() => {
        if (CardQrStyles) {
            setQrCodeOptions({
                dotsOptions: {
                    color: CardQrStyles.qrPatterncolor ?? "#000000",
                    type: CardQrStyles.qrPattern ?? "square"
                },
                cornersSquareOptions: {
                    color: CardQrStyles.eyeBallcolor ?? "#000000",
                    type: CardQrStyles.eyeBall ?? "dot"
                },
                cornersDotOptions: {
                    color: CardQrStyles.eyeFrameColor ?? "#000000",
                    type: CardQrStyles.eyeFrame ?? "dot"
                },
                backgroundOptions: {
                    color: CardQrStyles.addbgcolor ?? ""
                }
            });
        } else {
            console.log("Whether else condition works");
            setQrCodeOptions({
                dotsOptions: {
                    color: "#000000",
                    type: "square"
                },
                cornersSquareOptions: {
                    color: "#000000",
                    type: "dot"
                },
                cornersDotOptions: {
                    color: "#000000",
                    type: "dot"
                },
                backgroundOptions: {
                    color: ""
                }
            });
        }
    }, [CardQrStyles]);


    useEffect(() => {
        if (qrCodeRef.current) {
            if (Logo && !qrCodeInstanceRef.current) {
                console.log("Creating QR code with image", Logo);
                const qrCode = new QRCodeStyling({
                    width: 200,
                    height: 200,
                    data: url1,
                    ...qrCodeOptions,
                    image: Logo
                });
                qrCode.append(qrCodeRef.current);
                qrCodeInstanceRef.current = qrCode;
            } else if (!qrCodeInstanceRef.current) {
                console.log("Creating QR code without image");
                const qrCode = new QRCodeStyling({
                    width: 200,
                    height: 200,
                    data: url1,
                    ...qrCodeOptions
                });
                qrCode.append(qrCodeRef.current);
                qrCodeInstanceRef.current = qrCode;
            } else {
                console.log("Updating QR code123", Logo);
                qrCodeInstanceRef.current.update({ data: url1, ...qrCodeOptions });
                if (Logo && cardDetails.CardType != "Personal") {
                    qrCodeInstanceRef.current.update({ image: Logo });
                }
            }
        }
    }, [Logo, url1, qrCodeOptions, CardQrStyles]);

    const shouldShowContactSection = ContactStyles?.is_public && (
        ContactStyles?.address ||
        ContactStyles?.city ||
        ContactStyles?.state ||
        ContactStyles?.postal_code ||
        ContactStyles?.country
    );

    const layoutColor = CardStyles?.colorLayout || '#0044c6';

    const getLuminance = (hex) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16) / 255;
        const g = parseInt(hex.substring(2, 4), 16) / 255;
        const b = parseInt(hex.substring(4, 6), 16) / 255;

        const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        return luminance;
    };

    const [labelColor, setLabelColor] = useState('#ffffff');
    useEffect(() => {
        const luminance = getLuminance(layoutColor);
        if (luminance > 0.5) {
            setLabelColor('#000000'); // Dark text for light background
        } else {
            setLabelColor('#ffffff'); // Light text for dark background
        }
    }, [layoutColor]);

    const layoutStyle = CardStyles.layoutStyle ? CardStyles.layoutStyle : (CardStyles.CardType === 'Personal' ? '2' : '1');

    const layoutProps = {
        profilePicture: profilePicture,
        cardType: cardDetails?.CardType?.startsWith("Customize_") ? cardDetails?.CardName || "CardName" : cardDetails?.CardType,
        companyLogo,
        prefix: cardDetails?.prefix,
        suffix: cardDetails?.suffix,
        firstName,
        lastName,
        companyName: cardDetails?.company || "",
        designation: cardDetails?.designation || "",
        title: cardDetails?.title,
        colorPrimary: CardStyles.colorPrimary,
        colorSecondary: CardStyles.colorSecondary,
        colorTitle: CardStyles.colorTitle,
        bgColor: CardStyles?.bgColor || "#ffff",
        layoutColor,
        labelColor,
        handleOpenDialog: handleOpenDialogue,
        handleShareClick: handleClickOpen,
        phoneNo: ContactStyles?.mobile_number || userProfile.phone_no,
        emailId: ContactStyles?.email || userProfile.email,
        isVerified: cardDetails?.is_professional_verified,
        userDetails: userProfile
    };

    if (loading) {
        return (
            <div className="loader-container">
                <img src={loaderGif} alt="Loading..." height={100} width={100} />
            </div>
        );
    }

    const addressData = {

        city: "Banglore",
        state: "Karnataka",
        postal_code: "582101",
        country: "India",
    };

    const fullAddress = (ContactStyles?.address || ContactStyles.city)
        ? `${ContactStyles?.address}, ${ContactStyles?.city}, ${ContactStyles?.state} ${ContactStyles?.postal_code}, ${ContactStyles?.country}`
        : `${addressData.city}, ${addressData.state}, ${addressData.postal_code}, ${addressData.country}`;

    return (
        <>
            {userProfile !== null && (
                <>
                    <div className="row gx-0">
                        <div className="col-md-12 col-lg-3">
                            <div style={{ fontStyle: CardStyles?.style, fontFamily: CardStyles?.font, fontWeight: getFontWeight(CardStyles?.style), fontSize: CardStyles?.size, color: CardStyles?.colorSecondary }}>
                                <Box className="preview-card my-4 ms-4 user-details-box-1" sx={{ border: "2px solid #0000001F", borderRadius: 2, backgroundColor: CardStyles.bgColor }}>
                                    <div id='Card-firstPart-createNew'>
                                        {renderLayout(layoutStyle, layoutProps)}

                                        {CardStyles?.layoutStyle === '2' ? (<> </>) :
                                            <div className={`${CardStyles.layoutStyle === '4' ? 'line-card layout-4-extra-margin' : 'mt-2 line-card'}`}>
                                                <div className="line-blue" style={{ backgroundColor: layoutColor }}></div>
                                                <div className="icon icon-alignment-card d-flex align-items-center justify-content-center">
                                                    <div className='icon-border me-3 flex-center' style={{ borderColor: layoutColor }}>
                                                        <ImQrcode className='icon-color' onClick={handleOpenDialogue} />
                                                    </div>
                                                    <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: layoutColor }}>
                                                        {cardDetails?.is_professional_verified === true ? <VerifiedTickN title="Verified" /> : <NonVerifiedTickNew title="Not Verified" />}
                                                    </div>
                                                    <div className='icon-border flex-center' style={{ borderColor: layoutColor }}>
                                                        <IoMdShare className='icon-color' onClick={handleClickOpen} />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {/* <div className='preview-card-upper' style={{ backgroundImage: `url(${profilePicture})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                                            <div className='digi-card-label-container' style={{ backgroundColor: CardStyles?.colorLayout }}>
                                                <span className='digi-card-label'> {card}</span>
                                            </div>
                                            
                                            <div>
                                                <CardWaveStd bgColor={CardStyles?.bgColor} strokeColor={CardStyles?.colorLayout} />
                                            </div>

                                            {card != "Personal" &&
                                                <>
                                                    {(companyLogo && companyLogo.length !== 0) ? (
                                                        <div className='company-logo-container layout-1 new' style={{ backgroundImage: `url(${companyLogo})` }}>
                                                        </div>
                                                    ) : (
                                                        <div className='company-logo-container flex-center'>
                                                            <img src={DefaultProfileBg} alt='empty' className='default-logo-min-size' />
                                                        </div>
                                                    )}
                                                </>}

                                        </div> */}
                                        {/* <div className='preview-card-names'>
                                            <h3 style={{ color: CardStyles?.colorPrimary }}>{cardDetails?.prefix}{" "}{firstName}{" "}{lastName}</h3>
                                            {card === 'Professional' ?
                                                <h5>{userCompany} {" - "} {userDesignation} </h5>
                                                :
                                                <h5>{userTitle}</h5>
                                            }
                                        </div> */}

                                        <div className='summary-container'>
                                            {cardDetails?.summary}
                                        </div>

                                        {/* <div className="dialogue-overlay" style={{ display: dialogueOpen ? 'block' : 'none' }} onClick={handleCloseDialogue}>
                                            <div className='Scanner-outline-preview'>
                                                <div className='Displaying-QR'>
                                                    <span className='d-block text-center'>Scan me</span>
                                                    <div className={"qrCodeContainer"} style={borderStyle}>
                                                        <div ref={qrCodeRef}></div>
                                                    </div>
                                                    <span className='d-block text-center'>scan or click to preview</span>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="text-center mb-3">
                                            {isViewCard ? (<></>
                                            ) : (<>
                                                <Vcfcard userProfile={userProfile} cardDetails={cardDetails} ContactStyles={ContactStyles} />
                                                {console.log("UserProfile details is ", userProfile)}
                                            </>
                                            )}
                                        </div>

                                        <div className="dialogue-overlay" style={{ display: dialogueOpen ? 'block' : 'none' }} onClick={handleCloseDialogue}>
                                            <div className='Scanner-outline-preview'>
                                                <div className='Displaying-QR'>
                                                    <span className='d-block text-center'>Scan me</span>
                                                    <div className={"qrCodeContainer"}>
                                                        <div ref={qrCodeRef}></div>
                                                        {/* <QrCodeCard /> */}
                                                    </div>
                                                    <span className='d-block text-center'>scan or click to preview</span>
                                                </div>
                                            </div>
                                        </div>

                                        <BootstrapDialog
                                            onClose={handleClose}
                                            aria-labelledby="customized-dialog-title"
                                            open={popoverOpen}
                                            className="share-dialog"
                                        >
                                            <IconButton
                                                aria-label="close"
                                                onClick={handleClose}
                                                sx={{
                                                    position: "absolute",
                                                    right: 8,
                                                    top: 8,
                                                    color: (theme) => theme.palette.grey[500],
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                            <DialogContent
                                                dividers
                                                sx={{ m: 0, p: 2, width: 500 }}
                                            >
                                                <Typography gutterBottom sx={{ m: 0, p: 0, }}>
                                                    <div className="text-center">
                                                        <a
                                                            href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${card}/${id}`}
                                                            target='_blank'
                                                            rel="noreferrer"
                                                        >
                                                            <QrCodeCard CARDNAME_id={card} />
                                                        </a>
                                                    </div>
                                                </Typography>
                                                <Typography className="text-center  downloadShareButtonNew" gutterBottom>
                                                    <button className="download-share-button mt-n1" onClick={handleDownload}>
                                                        <Download className="dowload-share-icon" />
                                                        Download QR Code
                                                    </button>
                                                </Typography>
                                                <Typography className="mt-4" gutterBottom>
                                                    <div className="share-qr-content">
                                                        Share with your friends
                                                    </div>
                                                    <div className="share-qr-subcontent text-left mt-2">
                                                        Connect and Share with Friends
                                                    </div>
                                                </Typography>
                                                <Typography gutterBottom>
                                                    <div className="row mt-3">
                                                        <div className="d-flex justify-content-between">
                                                            {/* <a href="#facebook-link" target='_blank' rel='noreferrer'>
                                                                <img src={facebook} alt="facebook" className="share-icons mr-3" />
                                                            </a> */}
                                                            <a href={whatsappLink} target='_blank' rel='noreferrer'>
                                                                <img src={whatsapp} alt='whatsapp' className="share-icons mr-3" />
                                                            </a>
                                                            {/* <a href="#instagram-link" target='_blank' rel='noreferrer'>
                                                                <img src={insta} alt="instagram" className="share-icons mr-3" />
                                                            </a> */}
                                                            <a href={linkedinPostLink} target='_blank' rel='noreferrer'>
                                                                <img src={linkedin} alt="linkedin" className="share-icons mr-3" />
                                                            </a>
                                                            {/* <a href="#signal-link" target='_blank' rel='noreferrer'>
                                                                <img src={signal} alt="signal" className="share-icons mr-3" />
                                                            </a> */}
                                                            <a href={telegramLink} target='_blank' rel='noreferrer'>
                                                                <img src={telegram} alt='telegram' className="share-icons" />
                                                            </a>
                                                        </div>
                                                    </div>

                                                </Typography>
                                            </DialogContent>
                                        </BootstrapDialog>
                                    </div>
                                </Box>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <Box className="preview-card m-4 p-4 user-details-box-2" sx={{ border: "2px solid #0000001F", borderRadius: 2 }} >
                                <div className='d-flex align-items-center justify-content-between mt-4 quick-link-container user-details-2'>
                                    {ContactStyles?.call_visible && <div className='flex-center flex-column quick-link-icon'>
                                        <a href={`tel:${phoneNo}`} target='_blank' rel='noreferrer' className='flex-center flex-column' >
                                            <div className='icon icon-outside flex-center m-0' style={{ backgroundColor: CardStyles?.bgColor ? CardStyles.colorLayout : "#0044C6" }}><MdOutlinePhoneIphone className='icon-color3' /></div>
                                            <div className='text-center'>Call</div>
                                        </a>
                                    </div>}
                                    {ContactStyles?.sms_visible && <div className='flex-center flex-column quick-link-icon'>
                                        <a href={`sms:${phoneNo}`} target='_blank' rel='noreferrer' className='flex-center flex-column' >
                                            <div className='icon icon-outside flex-center m-0' style={{ backgroundColor: CardStyles?.bgColor ? CardStyles.colorLayout : "#0044C6" }}><SmsIcon className='icon-color3' /></div>
                                            <div className='text-center'>SMS</div>
                                        </a>
                                    </div>}
                                    {ContactStyles?.email_visible && <div className='flex-center flex-column quick-link-icon'>
                                        <a href={`mailto:${sms}`} target='_blank' rel='noreferrer' className='flex-center flex-column' >
                                            <div className='icon icon-outside flex-center m-0' style={{ backgroundColor: CardStyles?.bgColor ? CardStyles.colorLayout : "#0044C6" }}><EmailIcon className='icon-color3' /></div>
                                            <div className='text-center'>Email</div>
                                        </a>
                                    </div>}
                                    {ContactStyles?.whatsapp_visible && <div className='flex-center flex-column quick-link-icon'>
                                        <a href={`https://wa.me/${phoneNo}`} target='_blank' rel='noreferrer' className='flex-center flex-column' >
                                            <div className='icon icon-outside flex-center m-0' style={{ backgroundColor: CardStyles?.bgColor ? CardStyles.colorLayout : "#0044C6" }}><WhatsappFilled className='icon-color3' /></div>
                                            <div className='text-center'>WhatsApp</div>
                                        </a>
                                    </div>}
                                </div>

                                {/* <div className='mt-4'>
                                    <h5 style={{ color: CardStyles.colorTitle }}> My Social Network </h5>
                                    <div className="row user-details-social-icons professional-socialicons-container ">
                                       
                                            <div className="col-3 col-lg-2">
                                                <div className="square-box"><LinkedinIcon style={{height: "40px", width: "40px"}}/></div>
                                            </div>
                                            <div className="col-3 col-lg-2">
                                                <div className="square-box"><FacebookIcon style={{height: "40px", width: "40px"}}/></div>
                                            
                                            </div>
                                            <div className="col-3 col-lg-2">
                                            <a href={whatsappLink} target='_blank' rel='noreferrer'>
                                                <div className="square-box"><WhatsappIcon style={{height: "40px", width: "40px"}}/></div>
                                            </a>
                                            </div>
                                            <div className="col-3 col-lg-2">
                                                <div className="square-box"><InstagramIcon style={{height: "40px", width: "40px"}}/></div>
                                            </div>
                                    </div>
                                </div> */}

                                {anySocialIconsVisible && (
                                    <div className='mb-4 mx-3 social-icons-wrapper'>
                                        {socialLinksSections.map(section => (
                                            (section.title !== "Recommended") && ( // Exclude Recommended section
                                                <div className='my-4' key={section.title}>
                                                    {SocialLinks.links.some(link => link.visible && section.links.some(secLink => secLink.network === link.network)) && ( // Check if any visible icons under this section
                                                        <React.Fragment>
                                                            <h5 className='mb-2' style={{ color: CardStyles?.colorTitle || '' }}>{getDisplayTitle(section.title)}</h5>
                                                            <div className="social-icons-rows">
                                                                {SocialLinks.links.map((link) => (
                                                                    link.visible && section.links.some(secLink => secLink.network === link.network) && (
                                                                        <a key={link.network} href={link.url} target='_blank' rel='nonreferrer'>
                                                                            <div className="square-box">
                                                                                {/* Get the icon using getIconAndLabel */}
                                                                                {(() => {
                                                                                    const { icon: Icon } = getIconAndLabel(link.network);
                                                                                    return Icon ? <Icon className="social-icon svg-icon-32px" /> : null;
                                                                                })()}
                                                                            </div>
                                                                        </a>
                                                                    )
                                                                ))}
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            )
                                        ))}
                                    </div>
                                )}

                            </Box>
                        </div>
                        <div className="col-md-12 col-lg-3">
                            <Box className="preview-card my-4 me-4 p-4 user-details-box-3" sx={{ border: "2px solid #0000001F", borderRadius: 2 }}>

                                {/* <div className='mt-4 mx-3'> */}
                                {/* <h5 style={{ color: CardStyles ? CardStyles.colorTitle : "#000000" }}> Files </h5> */}
                                {AttachDocs.images.length === 0 && AttachDocs.videos.length === 0 && AttachDocs.others.length === 0 ? (<></>
                                    // <p>No files uploaded yet. {console.log("inside ? ...")} </p>
                                ) : (
                                    <div>
                                        {visibleImages.length > 0 && (
                                            <div>
                                                <div className="professional-social-title mb-2">Images</div>
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', maxHeight: '220px', justifyContent: "center" }}>
                                                    {visibleImages.map((file, index) => (
                                                        <div key={index} style={{ width: '99px', height: '100px', boxSizing: 'border-box' }}>
                                                            <img src={file.data} alt={file.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
                                                        </div>
                                                    ))}
                                                    {AttachDocs.images.length > maxImages && (
                                                        <div
                                                            style={{ width: '99px', height: '100px', boxSizing: 'border-box', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#e0e0e0', borderRadius: '8px' }}
                                                            onClick={handleViewMoreClick}
                                                        >
                                                            <span>{AttachDocs.images.length - maxImages}+ View More</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {visibleFiles(AttachDocs.videos).length > 0 && (
                                            <div className='my-2'>
                                                <div className="professional-social-title">Video</div>
                                                {visibleFiles(AttachDocs.videos).map((file, index) => (
                                                    <div key={index}>
                                                        <ReactPlayer url={file.data} loop controls className='mx-auto preview-media-display' />
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        {visibleFiles(AttachDocs.others).length > 0 && (
                                            <div className='my-2'>
                                                <div className="professional-social-title">Files</div>
                                                {visibleFiles(AttachDocs.others).map((file, index) => (
                                                    <div key={index} className="my-2">
                                                        {/* <a href={`data:${file.type};base64,${file.data}`} target='_blank' rel='noreferrer'> */}
                                                        <PreviewFileItem file={file} fontColor="blue-magenta" />
                                                        {/* </a> */}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {/* </div>s */}


                                <Modal open={isModalOpen} onClose={handleCloseModal}>
                                    <Box sx={{ maxWidth: '80%', margin: 'auto', padding: '20px', backgroundColor: 'white', borderRadius: '8px', overflowY: 'auto' }}>
                                        <h2>All Images</h2>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                            {visibleFiles(AttachDocs.images).map((file, index) => (
                                                <div key={index} style={{ flex: '1 1 calc(25% - 10px)', boxSizing: 'border-box' }}>
                                                    <img src={file.data} alt={file.name} style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '8px' }} />
                                                </div>
                                            ))}
                                        </div>
                                    </Box>
                                </Modal>
                                {/* <div className="video-container mx-3 mt-3">
                                    <div className="professional-social-title">Video</div>
                                    <div className="video-content-container mt-3 w-auto"></div>
                                </div>
                                <div className="pdf-container mx-3 mt-3">
                                    <div className="professional-social-title">PDF</div>
                                    <div className="rectangle-pdf-container mt-3 w-auto"></div>
                                </div> */}
                                <div className='mt-3'>
                                    <div className="professional-social-title">Location</div>
                                    <div className="professional-map-containerNew mt-3 flex-center width-auto">
                                        {/* <MapIntegration style={{ borderRadius: "6px" }} latitude="12.9798710248994" longitude="77.60654611960474" /> */}
                                        <MapWithAddress address={fullAddress} style={{ borderRadius: "6px" }} />
                                    </div>
                                </div>

                                {shouldShowContactSection && (
                                    <div className='mt-4 mx-3'>
                                        <div className="professional-social-title">Contact</div>
                                        <div className='box-paragraph' style={{ fontSize: "16px", lineHeight: "24px" }}>
                                            {ContactStyles?.address && (
                                                <div className='d-flex justify-content-start'>
                                                    <div className='ms-1'>Address:</div>
                                                    <div className='mx-2'>{ContactStyles.address}</div>
                                                </div>
                                            )}

                                            {ContactStyles?.city && (
                                                <div className='d-flex justify-content-start'>
                                                    <div className='ms-1'>City:</div>
                                                    <div className='mx-2'>{ContactStyles.city}</div>
                                                </div>
                                            )}

                                            {ContactStyles?.state && (
                                                <div className='d-flex justify-content-start'>
                                                    <div className='ms-1'>State:</div>
                                                    <div className='mx-2'>{ContactStyles.state}</div>
                                                </div>
                                            )}

                                            {ContactStyles?.country && (
                                                <div className='d-flex justify-content-start'>
                                                    <div className='ms-1'>Country:</div>
                                                    <div className='mx-2'>{ContactStyles.country}</div>
                                                </div>
                                            )}

                                            {ContactStyles?.postal_code && (
                                                <div className='d-flex justify-content-start'>
                                                    <div className='ms-1'>Postal:</div>
                                                    <div className='mx-2'>{ContactStyles.postal_code}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                            </Box>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default CardView